function formatDate(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate();

  const ordinal = (n: number) =>
    n > 3 && n < 21 ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][n % 10];

  const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);

  return `${day}${ordinal(day)} ${month} ${date.getFullYear()}`;
}

function fetchBlogTypeStylings(blogType: string) {
  const typeStyling = {
    bg: "bg-[#FEF2FF]",
    border: "border-[#EB53FF]",
    text: "text-[#EB53FF]",
  };

  if (blogType === "Technical") {
    typeStyling.bg = "bg-[#FDF6EB]";
    typeStyling.border = "border-[#F7AA1C]";
    typeStyling.text = "text-[#F7AA1C]";
  } else if (blogType === "Newsletter") {
    typeStyling.bg = "bg-[#EEFDEC]";
    typeStyling.border = "border-[#63E418]";
    typeStyling.text = "text-[#63E418]";
  }
  else if (blogType === "Industry") {
    typeStyling.bg = "bg-[#EEF5FB]";
    typeStyling.border = "border-[#2B7FD9]";
    typeStyling.text = "text-[#2B7FD9]";
  }

  return typeStyling;
}


export { formatDate, fetchBlogTypeStylings };
